export default "__VITE_ASSET__BKdH09I7__"